<template>
  <div>
    Released Escrow {{seq}}
  </div>
</template>

<script>
import CurrencyAmount from '../CurrencyAmount.vue'

var HasTx = require('../../mixins/has_tx')

export default {
  name   : 'EscrowFinishTx',

  mixins : [HasTx],

  components : {
    CurrencyAmount
  },

  computed : {
    seq : function(){
      return this.tx_obj["OfferSequence"];
    }
  }
}
</script>

<style scoped>
</style>
